export default __webpack_public_path__ + "static/euroBadgeLogo-98af9bfed21efe1c37b091b527ad35bd.svg";